import React, { useState } from "react";

import BillingDetail from "./SubscriptionsTabs/BillingDetail";
import RenewStep from "./SubscriptionsTabs/RenewStep";
import PaymentCheckout from "./SubscriptionsTabs/PaymentCheckout";
import PaymentStep from "./SubscriptionsTabs/PaymentStep";
import PaymentSuccess from "./PaymentSuccess";
import { useLoginUser } from "../../../../../../hooks/useLoginUser";

const getProgressTabs = (step) => [
  {
    title: "Choose Your Plan",
    icon: "group_add",
    color: step >= 2 ? "success" : step === 1 ? "primary" : "",
    status: step >= 2 ? "Completed" : step === 1 ? "In Progress" : "",
  },
  {
    title: "Customize Your Plan",
    icon: "assignment",
    color: step >= 3 ? "success" : step === 2 ? "primary" : "",
    status: step >= 3 ? "Completed" : step === 2 ? "In Progress" : "",
  },
  {
    title: "Checkout",
    icon: "shopping_cart",
    color: step === 3 ? "primary" : step === 4 ? "success" : "",
    status: step === 3 ? "In Progress" : step === 4 ? "Completed" : "",
  },
];

const Subscriptions = () => {
  const [step, setStep] = useState(0);
  const { userData: loginUserData } = useLoginUser();
  return loginUserData?.role?.module === 4 ? (
    <div className="flex flex-col justify-center items-center flex-1 overflow-auto ">
      <div className="flex flex-col justify-center items-center m-10">
        <h1 className="flex font-bold text-center items-center  break-words">
          Subscription
        </h1>
        <h2 className="flex font-bold text-center items-center  break-words">
          Coming soon
        </h2>
      </div>
    </div>
  ) : (
    <>
      {step === 0 && (
        <BillingDetail
          onContinue={() => setStep(1)}
          tabs={getProgressTabs(step)}
        />
      )}
      {step === 1 && (
        <RenewStep
          onBack={() => setStep(0)}
          onContinue={() => setStep(2)}
          tabs={getProgressTabs(step)}
        />
      )}
      {step === 2 && (
        <PaymentCheckout
          onBack={() => setStep(1)}
          onContinue={() => setStep(3)}
          tabs={getProgressTabs(step)}
        />
      )}
      {step === 3 && (
        <PaymentStep
          onBack={() => setStep(2)}
          onContinue={() => setStep(4)}
          tabs={getProgressTabs(step)}
        />
      )}
      {step === 4 && (
        <PaymentSuccess
          onBack={() => setStep(0)}
          tabs={getProgressTabs(step)}
        />
      )}
    </>
  );
};

export default Subscriptions;
